import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import AuthContext from "./Services/AuthContext";
import jwt_decode from "jwt-decode";
import {DefaultEffects, FontSizes, FontWeights, PrimaryButton, Stack, TextField} from '@fluentui/react';
import {Image} from '@fluentui/react/lib/Image';

function Login() {
    const [user, setUser] = useContext(AuthContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token !== "" && user.expiry > Date.now()) {
            navigate("/");
        }
    }, [user]);

    const authenticate = (e) => {
        e.preventDefault();
        const sentData = { username: username, password: password };

        fetch("/api/login_check", {
            cache: "no-cache",
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(sentData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                response.json().then(function (data) {
                    const decoded = jwt_decode(data.token);
                    const user = { username: sentData.username, token: data.token, expiry: decoded.exp * 1000, roles: decoded.roles};
                    setUser(user);
                });
            })
            .catch((error) => {
                console.log(error.message);
            });
    };

    return (<div className={"bg-intro"}><Stack horizontalAlign="center" verticalAlign="center" style={{height: '85vh'}}>
            <div className={'login-panel '} style={{boxShadow: DefaultEffects.elevation16}}>
                <Image src={process.env.PUBLIC_URL + '/favicon/android-icon-192x192.png'} alt={'Xonite One'} width={192} heigth={192} styles={{root: {margin: "0 auto"}}}/>
                <h1 style={{fontWeight: FontWeights.light, fontSize: FontSizes.size32, marginTop: 0}}>Xonite One</h1>
                <form onSubmit={authenticate}>
                    <TextField label='Login' value={username} onChange={(e) => setUsername(e.target.value)} />
                    <TextField label='Password' type='password' value={password} onChange={(e) => setPassword(e.target.value)}/>
                    <PrimaryButton type="submit" text={'Zaloguj'} />
                </form>
            </div>
        </Stack>
        </div>
    );
}

export default Login;